export const SELECTED_COLOR = '#EA0BBD';
export const GRAPH_HEIGHT = 600;
export const GRAPH_WIDTH = 120;
export const MIN_TICK_HEIGHT = 6;
export const MAX_TICK_HEIGHT = GRAPH_HEIGHT - 6;
export const BUBBLE_SIZE = 64;
export const MIN_BUBBLE_HEIGHT = 4;
export const MAX_BUBBLE_HEIGHT = GRAPH_HEIGHT - 4;
export const clampTickHeight = (height: number) =>
  Math.min(MAX_TICK_HEIGHT, Math.max(MIN_TICK_HEIGHT, height));
export const clampBubbleHeight = (height: number) =>
  Math.min(
    MAX_BUBBLE_HEIGHT - BUBBLE_SIZE / 2,
    Math.max(MIN_BUBBLE_HEIGHT + BUBBLE_SIZE / 2, height)
  );
export const DEFAULT_SELECTED_ITEM: SelectedItem = { type: 'unselected' };
export const BAR_SEGMENT_ANIMATION_DURATION = 1;
export const GRADE_LABEL_ANIMATION_DURATION = 1;
export const PASSING_SCORE = 0.9;

export const GRADE_MAPPINGS = {
  '-1': { shortName: 'Pre-Kindergarten' },
  0: { shortName: 'Kindergarten' },
  1: { shortName: '1st Grade' },
  2: { shortName: '2nd Grade' },
  3: { shortName: '3rd Grade' },
  4: { shortName: '4th Grade' },
  5: { shortName: '5th Grade' },
  6: { shortName: '6th Grade' },
  7: { shortName: '7th Grade' },
  8: { shortName: '8th Grade' },
  9: { shortName: '9th Grade' },
  10: { shortName: '10th Grade' },
  11: { shortName: '11th Grade' },
  12: { shortName: '12th Grade' },
};

export type GradeTestData = {
  name: string;
  highScore: number;
  highScoreDate: Date;
};

type SelectedGrade = {
  type: 'grade';
  data: {
    date: string;
    height: number;
    /**
     * Text visible on label (e.g. "7th grade")
     **/
    label: string;
    testScore: string;
    /**
     * Internal value of selection (e.g. "7")
     **/
    value: string;
  };
};
type SelectedMonth = {
  type: 'month';
  data: {
    height: number;
    numLessons: number;
    value: string;
  };
};
type NoSelection = { type: 'unselected' };
export type SelectedItem = SelectedGrade | SelectedMonth | NoSelection;
export type NewSelection = Exclude<SelectedItem, NoSelection>;
export type BarSegment = {
  barBottom: number;
  barTop: number;
  barHeight: number;
  bgColor: string;
  value: string;
  numLessons: number;
};
